export default [{
  path: '/telegram-quiz',
  name: 'telegramQuiz',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/quiz/telegramQuiz/index')
}]
